import React from 'react'
import {
    Modal,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Button
} from 'reactstrap'
import {Query, Mutation} from 'react-apollo'
import {AvForm, AvField} from 'availity-reactstrap-validation'
import PropTypes from 'prop-types'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import Loading from "../Loading"
import query from '../../../queries/server/system_setting'
import localMutation from '../../../queries/client_side/mutations/update_system_setting'
import serverMutation from '../../../queries/server/mutations/update_system_setting'
import {toast} from "react-toastify";

const SystemSettingModal = (props) => {

    const getInputType = (typeID) => {
        switch (typeID) {
            case 1:
                return 'number'
                break
            case 2:
                return 'text'
                break
            case 3:
                return 'textarea'
        }
    }

    if (!props.settingID) return null

    return (
        <Query query={query} variables={{id: props.settingID}} fetchPolicy="network-only">
            {({data, loading}) => {

                if (loading) return (
                    <Modal>
                        <ModalBody>
                            <Loading/>
                        </ModalBody>
                    </Modal>
                )

                const {id, description, setting_type_id, setting_value} = data.system_setting

                return (
                    <Mutation mutation={serverMutation}>
                        {(serverMutationFunc, {loading}) => (
                            <Mutation mutation={localMutation}>
                                {(localMutationFunc) => (
                                    <Modal isOpen={props.isOpen} toggle={props.toggle}>
                                        <AvForm
                                            onValidSubmit={() => {
                                                serverMutationFunc({variables: {data: {id, setting_value}}})
                                                    .then((res) => {
                                                        if(props.onSave) props.onSave()
                                                        toast.success('System Setting Updated', {autoClose: 2000})
                                                        props.toggle()
                                                    })
                                                    .catch(e => toast.error(e.message, {autoClose: false}))
                                            }}
                                        >
                                            <ModalHeader>
                                                Edit {description}
                                            </ModalHeader>

                                            <ModalBody>
                                                <AvField
                                                    required
                                                    type={getInputType(setting_type_id)}
                                                    name="the_input"
                                                    label={`${description}*`}
                                                    bsSize="sm"
                                                    errorMessage="Required"
                                                    value={setting_value}
                                                    style={(getInputType(setting_type_id) === 'textarea') ? {height: '180px'} : {}}
                                                    onChange={(evt) => {
                                                        localMutationFunc({
                                                            variables: {
                                                                data: {
                                                                    id,
                                                                    description,
                                                                    setting_type_id,
                                                                    setting_value: evt.target.value
                                                                }
                                                            }
                                                        })
                                                    }}
                                                />
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button
                                                    size="sm"
                                                    color="secondary"
                                                    onClick={props.toggle}>
                                                    <FontAwesomeIcon
                                                        color="#fff"
                                                        icon="times"/>{' '}
                                                    Cancel
                                                </Button>
                                                <Button
                                                    size="sm"
                                                    color="success"
                                                    disabled={loading}
                                                >
                                                    <FontAwesomeIcon
                                                        color="#fff"
                                                        icon={loading ? 'spinner' : 'save'}
                                                        spin={loading}
                                                    />
                                                    {' '}
                                                    {loading ? 'Saving...' : 'Save'}
                                                </Button>
                                            </ModalFooter>
                                        </AvForm>
                                    </Modal>
                                )}
                            </Mutation>
                        )}
                    </Mutation>
                )

            }
            }
        </Query>
    )

}

SystemSettingModal.propTypes = {
    toggle: PropTypes.func,
    isOpen: PropTypes.bool,
    onSave: PropTypes.func,
    settingID: PropTypes.number
}

export default SystemSettingModal